<template>
    <div class="container-fluid mb-5 ps-5">
        <div class="row">
            <div class="col">
                <img @click="$emit('go-back-event')" src="../../assets/back-button.svg" class="img-fluid cursor-pointer" width="32" alt="">
            </div>
        </div>
    </div>
    <div class="container">
        <div class="row">
            <div class="col text-center">
                <h1 class="thin-text mb-5 fs-3">Cosa voglio realizzare?</h1>
            </div>
        </div>
    </div>
    <div class="custom-container">
        <form @submit.prevent="validateForm" id="formId" method="post" novalidate="true">
            <div class="row mb-5">
                <div class="col-lg-3"></div>
                <div class="col-lg-3">
                    <label class="custom-checkbox">
                        <input v-model="eventTypes" type="checkbox" name="eventType1" id="PrimaCasa" value="Prima casa" required @change="sendEventList()">
                        <img class="mb-3" src="../../assets/realizzare-screen/1/prima-casa.png" alt="">
                        <span class="thin-text">Prima casa</span>
                    </label>
                </div>
                <div class="col-lg-3">
                    <label class="custom-checkbox">
                        <input  v-model="eventTypes"  type="checkbox" name="eventType2" id="Diploma" value="Diploma" required @change="sendEventList()">
                        <img class="mb-3" src="../../assets/realizzare-screen/1/diploma.png" alt="">
                        <span class="thin-text">Diploma</span>
                    </label>
                </div>
                <div class="col-lg-3">
                    <label class="custom-checkbox">
                        <input v-model="eventTypes" type="checkbox" name="eventType3" id="Laurea" value="Laurea" required @change="sendEventList()">
                        <img class="mb-3" src="../../assets/realizzare-screen/1/laurea.png" alt="">
                        <span class="thin-text">Laurea</span>
                    </label>
                </div>
            </div>
             <div class="row mb-5">
                <div class="col-lg-3">
                    <label class="custom-checkbox">
                        <input  v-model="eventTypes" type="checkbox" name="eventType4" id="Matrimonio" value="Matrimonio" required @change="sendEventList()">
                        <img class="mb-3" src="../../assets/realizzare-screen/1/matrimonio.png" alt="">
                        <span class="thin-text">Matrimonio</span>
                    </label>
                </div>
                <div class="col-lg-3">
                    <label class="custom-checkbox">
                        <input  v-model="eventTypes" type="checkbox" name="eventType5" id="Nascita" value="Nascita primo figlio/a" required @change="sendEventList()">
                        <img class="mb-3" src="../../assets/realizzare-screen/1/nascita.png" alt="">
                        <span class="thin-text">Nascita primo figlio/a</span>
                    </label>
                </div>
                <div class="col-lg-3">
                    <label class="custom-checkbox">
                        <input  v-model="eventTypes" type="checkbox" name="eventType6" id="Età" value="Età importante" required @change="sendEventList()">
                        <img class="mb-3" src="../../assets/realizzare-screen/1/eta.png" alt="">
                        <span class="thin-text">Età importante</span>
                    </label>
                </div> 
                <div class="col-lg-3 d-flex align-items-center"  v-if="this.formData.eventTypes.includes('Età importante')">
                    <input v-model="formData.eventAge" type="number" class="form-control" id="eta" placeholder="Età">
                </div>
            </div>
            
            <div class="text-center mb-3">
                <input type="submit" value="Procedi">
            </div>
        </form>

    </div>
    <div class="container" v-if="this.errors.length > 0">
        <div class="row">
            <ul class="list-unstyled col-lg-6 offset-3">
                <li class="alert alert-danger p-2 mb-1" role="alert" :key="key" v-for="(error, key) in this.errors">
                    {{error}}
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'RealizeScreen',
        emits: ['go-to-event', 'go-back-event', 'save-form-data-event'],
        props: {
            formData: {
                type: Object,
                default(rawProps) {
                    return {
                        eventTypes: [],
                        eventAge: null,
                    }
                }
            }
            
        },
        data() {
            return {
                errors: [],
                eventTypes: this.formData.eventTypes
            }
        },
        methods: {
            validateForm() {
                // Check for errors
                this.errors = [];
                if (this.formData.eventTypes.length == 0 ) {
                    this.errors.push("Cosa voglio realizzare mancante");
                }
                if (this.formData.eventTypes.includes("Età importante")) {
                    if (!this.formData.eventAge || this.formData.eventAge == "") {
                        this.errors.push("Età mancante");
                    }
                }
                
                // No errors found
                if (this.errors.length == 0) {
                    this.$emit('save-form-data-event', this.formData);
                    this.$emit('go-to-event', 'ContractFiguresScreenId');
                    return true;
                }
                
            },
            sendEventList(){
                this.formData.eventTypes = [];
                this.formData.eventTypes = this.eventTypes;
            },
        }
    }
</script>